import React, { useEffect, useRef, useState } from 'react';
import style from "./LevelThreeReviewRemark.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import Table from '../../../components/CommonComponents/Table/Table';
import Green from "../../assets/appDocImages/streamline_interface-id-iris-scan-check-identification-retina-security-approved-success-iris-scan-eye-login.svg";
import Red from "../../assets/appDocImages/material-symbols_tab-close-outline-rounded.svg";
import Eye from "../../assets/appDocImages/ic_baseline-remove-red-eye.svg";
import Download from "../../assets/appDocImages/ic_baseline-file-download.svg";
import Upload from "../../assets/appDocImages/ic_baseline-upload.svg";
import Close from "../../assets/appDocImages/material-symbols_close.svg";
import History from "../../../assets/appDocImages/material-symbols_history.svg";
import tickGreen from "../../../assets/images/gif/geentick.gif"
import tickRed from "../../../assets/images/gif/geentick.gif"
import icon from "../../../assets/images/brand/logo_2_107x70.png";
import axios from 'axios';
import { ErrorToast, SuccessToast } from '../../../components/toastMessage';
import Timeline from '../../timeLine/timelineEvent';
import Multiselect from 'multiselect-react-dropdown';
import Modal from "react-bootstrap/Modal";
import { MDBCard, MDBCardBody, MDBContainer, MDBIcon } from "mdb-react-ui-kit";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { BASE_URL } from '../../../constants/Constants';
import user from "../../../assets/images/user.svg";
import { formatDate } from '../../../utils/date';


const LevelThreeReviewRemark = () => {
    const { state } = useLocation();
    const documentData = state?.documentData;
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [timelineData, setTimelineData] = useState([]);
    const [formatDateTime, setFormatDateTime] = useState([]);
    const [file, setFile] = useState()
    const [isRightSelected, setIsRightSelected] = useState(true);
    const [isWrongSelected, setIsWrongSelected] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showGifModal, setShowGifModal] = useState(false);
    const [showRedGifModal, setShowRedGifModal] = useState(false);
    const [adminDoc, setadminDoc] = useState<Array<any>>([]);
    const [adminNoc, setadminNoc] = useState<Array<any>>([]);
    const [columnsList, setcolumnsList] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const docRef = useRef<any>(null)
    const [comment, setComment] = useState([]);
    const [textFieldValue, setTextFieldValue] = useState('');
    const [showButton, setShowButton] = useState(true);
    const [formData, setFormData] = useState({
        decision: documentData?.decision === 1 ?? false,
    });
    const [appFormData, setAppFormData] = useState({
        status: documentData?.status === 1 ?? "",
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isReturned, setIsReturned] = useState(false);
    const location = useLocation();

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const openRevivewModal = () => {
        setShowModal(true);
    };

    const convertFieldName = (fieldName: string) => {
        // Split the field name by underscores and capitalize each word
        const words = fieldName.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1));
        // Join the words with a space
        return words.join(' ');
    };

    const navigate = useNavigate();

    const handleReturnClick = () => {
        if (selectedOptions.length === 0) {
            // Display error toast if text field is empty
            ErrorToast('Returned field cannot be empty');
        } else {
            // Display success toast if text field has data
            // SuccessToast('Application Submitted');
            setIsReturned(true);
            setShowRedGifModal(true);
            // updateComment
        }
    };

    const handleForwardClick = () => {
        if (textFieldValue.trim() === '') {
            // Display error toast if text field is empty
            ErrorToast('Reviewers Remark field cannot be empty');
        } else {
            // Display success toast if text field has data
            // SuccessToast('Application Submitted');
            setIsSubmitted(true);
            setShowGifModal(true);
            // updateComment
        }
    };

    

  return (
    <div>
      <div className={style.body}>
            <div className={style.navbar}>
                <div className={`${style.userform} p-10`}>
                    <div className={style.divbodyheading}>
                        <p className={style.bodytitle}>Previous Reviewer Remark</p>
                    </div>
                    {/* Main Content */}
                    {/* Document Table  */}
                    <br />
                    {/* NOC Table  */}
                    <div className={style.BootContainer}> 
                    <Container className={style.BootContainer}>
      <Row className={style.rowGrid} style={{alignItems: "center"}}>
        <Col>
        <div className={style.reviewerBox}>

        <h4 className={style.reviewerName}> Level 1 Reviewer Name: </h4>

        <div className={style.reviewerInfo}>
            <img src={user} alt="" className={style.reviewerImg}/>
            <div className={`${style.userInfo} m-1`}>
            <label className={style.reviewerTitle}>Kevin M.</label>
            <p className={style.reviewerDate}>24/05/2023</p>
            </div>
            </div>
        </div>
        <div className={style.RemarkBox}>
        <h4 className={style.remarkLabel}> Level 1 Reviewer Remark </h4>
        
        <div className={style.reviewBoxScroll}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book

        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book

        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book

        </div>

        </div>

        </Col>
        {/* <div  className={`${style.dividerLine} col-auto`}></div> */}
        <Col><div className={style.reviewerBox}>

<h4 className={style.reviewerName}> Level 2 Reviewer Name: </h4>

<div className={style.reviewerInfo}>
    <img src={user} alt="" className={style.reviewerImg}/>
    <div className={`${style.userInfo} m-1`}>
    <label className={style.reviewerTitle}>Kevin M.</label>
    <p className={style.reviewerDate}>24/05/2023</p>
    </div>
    </div>
</div>
<div className={style.RemarkBox}>
<h4 className={style.remarkLabel}> Level 2 Reviewer Remark </h4>

<div className={style.scrollContainer}>

<div className={style.reviewBoxScroll}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book

Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book

Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book
</div>
</div>


</div>
</Col>
      </Row>

    </Container>
    </div>
                    <br />
                    {/* Modal */}
                    <>
                        <Modal
                            size="xl"
                            show={isModalOpen}
                            onHide={() => setIsModalOpen(false)}
                            aria-labelledby="example-modal-sizes-title-vcenter-lg"
                            centered
                        >
                            <div className={style.modalPd}>
                                <Modal.Header
                                    closeButton
                                    style={{
                                        backgroundImage: "revert-layer !important",
                                    }}
                                >
                                    <div style={{ width: "100%" }}>
                                        <h5 className={style.popUpHeading}>Document Name</h5>
                                    </div>
                                </Modal.Header>

                                <Modal.Body>
                                    {/* document page */}
                                    <div className={style.docBox}>
                                        <div className={style.pdfFrame}>
                                            <iframe
                                                title="PDF Viewer"
                                                src="https://arxiv.org/pdf/quant-ph/0410100.pdf#page=1&zoom=150"
                                                className={`${style.orgPdf} transparentBorder`}
                                            ></iframe>
                                        </div>
                                    </div>

                                    <div className={style.updateSection}>
                                        <button className={style.updateButton} onClick={() => closeModal()}> Update </button>
/                                    </div>
                                </Modal.Body>
                            </div>
                        </Modal>
                    </>
                  
                    {/* Review Modal */}
                    <>
                        <Modal
                            size="lg"
                            show={showModal}
                            onHide={() => setShowModal(false)}
                            aria-labelledby="example-modal-sizes-title-vcenter-lg"
                            centered
                        >
                            <div className={style.modalPd}>
                                <Modal.Header
                                    closeButton
                                    style={{
                                        backgroundImage: "revert-layer !important",
                                    }}
                                >
                                    <div style={{ width: "100%" }}>
                                        <h5 className={style.popUpHeading}>Previous Review</h5>
                                    </div>
                                </Modal.Header>

                                <Modal.Body>
                                    <MDBContainer fluid className="py-5 gradient-custom-5">
                                        <ul className="timeline-with-icons">
                                            <li className="timeline-item mb-5">
                                                {timelineData.length === 0 ? (
                                                    <div className={style.noRecordsMessage}>
                                                        No Comments found
                                                    </div>
                                                ) : (
                                                    timelineData.map((receipt: any, index) => (
                                                        <div className={style.mainTimeline} key={index}>
                                                            <div
                                                                key={index}
                                                            >
                                                                <MDBCard
                                                                    style={{
                                                                        width: "380px",
                                                                        backgroundColor: "#fff",
                                                                        border: "none",
                                                                    }}
                                                                >
                                                                    <MDBCardBody>
                                                                        <span className="timeline-icon">
                                                                            <MDBIcon class="fa fa-user-circle-o" aria-hidden="true" color="primary" size="sm" />
                                                                            {/* <h5 className={style.whiteTxt}>
                                                                                 {receipt.reviwerName}
                                                                            </h5> */}
                                                                            {formatDate(new Date(receipt.date))}
                                                                        </span>
                                                                        <p className="mt-2 mb-0">
                                                                            <div className={style.timelineMessage}>
                                                                                <div> {receipt.comment_text}</div>
                                                                            </div>
                                                                        </p>
                                                                    </MDBCardBody>
                                                                </MDBCard>
                                                            </div>
                                                        </div>
                                                    ))
                                                )}
                                                {/* </div> */}
                                            </li>
                                        </ul>
                                    </MDBContainer>
                                </Modal.Body>
                            </div>
                        </Modal>
                    </>
                    {/* {showModal && (
                        <div className={style.modal}>
                            <button className={style.closeIcon} onClick={() => closeReviewModal()}>
                                <img src={Close} alt="Close Icon" />
                            </button>
                            <div className={style.modalRow}>
                                <Timeline /> */}
                    {/* <button onClick={() => closeReviewModal()}>
                                    <img src={Close} alt="Close Icon" />
                                </button> */}
                    {/* </div>
                        </div>
                    )} */}

                    {isSubmitted && showGifModal && (
                        <div className={style.gifModal}>
                            <div className={style.verificationContainer}>
                                <img src={icon} alt="Logo" className={style.logoCss} />
                                <img src={tickGreen} alt="Success GIF" className={style.tickDone} />
                                <h2 className={style.boldGreen}>Application Forwarded</h2>
                                <br />
                                <h6 className={style.successfulMessage}>
                                    User application forwarded. Status sent to user.
                                </h6>
                            </div>
                        </div>
                    )}

                    {isReturned && showRedGifModal && (
                        <div className={style.gifModal}>
                            <div className={style.verificationContainer}>
                                <img src={icon} alt="Logo" className={style.logoCss} />
                                <img src={tickRed} alt="Success GIF" className={style.tickDone} />
                                <h2 className={style.boldGreen}>Application Returned</h2>
                                <br />
                                <h6 className={style.successfulMessage}>
                                    User application returned. Status sent to user.
                                </h6>
                            </div>
                        </div>
                    )}

                    
                    <div className={style.headerRow}>
                        <label htmlFor="levelOneReviewerRemark" className={style.smallLable}>Level 2 Reviewer Remark<span className="text-red-500">{' *'}</span> </label>
                        <button className={style.headerLable} onClick={() => openRevivewModal()}>
                            <img src={History} alt="Review History" />
                            <label htmlFor="reviewHistory" >Previous Review</label>
                        </button>
                    </div>

                    <div className={style.formrow}>

                        <div className={style.fieldGroup}>
                            <div className={style.fieldSection}>
                                <input
                                    type="text"
                                    id="comment_text"
                                    className={style.commentBox}
                                    placeholder="Add Comment"
                                    onChange={(e) => setTextFieldValue(e.target.value)}
                                />
                            </div>
                            <div className={style.searchSelect}>
                                <Multiselect
                                    displayValue="key"
                                    onKeyPressFn={function noRefCheck() { }}
                                    onRemove={function noRefCheck() { }}
                                    onSearch={function noRefCheck() { }}
                                    onSelect={function handelSelect(data) { setSelectedOptions(data) }}
                                    className={style.multiselectContainer}
                                    placeholder='Search'
                                    closeIcon="cancel"
                                    options={columnsList.map((e: any) => ({
                                        cat: 'Group 1',
                                        key: convertFieldName(e.COLUMN_NAME)
                                    }))}
                                    showCheckbox
                                />
                        </div>
                        </div>

                        <div className={style.formgroup}>
                            <div className={style.buttonSection}>

                            </div>
                            {selectedOptions.length > 0 ? (
                                <><div className={style.buttonSection}>
                                    <button className={style.returnButtonOnChange} onClick={handleReturnClick}> Return </button>
                                </div><div className={style.buttonSection}>
                                        <button className={style.forwardButtonOnChange}> Forward </button>
                                        <button className={style.forwardButton} onClick={handleForwardClick} > Reject </button>
                                    </div></>
                            ) : (
                                <><div className={style.buttonSection}>
                                    <button className={style.returnButton} onClick={handleReturnClick}> Return </button>
                                </div><div className={style.buttonSection}>
                                        <button className={style.returnButton} onClick={handleForwardClick} > Reject </button>
                                    </div></>
                            )}
                        </div>
                    </div>
                    <div className={style.BottomButtonSection}>
                    <button className={style.closeButton}>Back</button>
            <button className={style.publishButton} >
             Save
            </button>

            <button className={style.generateBtn}>Approve & Next</button>
          </div>
                </div>
               
            </div >
        </div >
    </div>
  )
}

export default LevelThreeReviewRemark
